import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-project_list",
  "use": "icon-project_list-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-project_list\"><g transform=\"translate(2 2)\"><rect stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"2\" x=\"1\" y=\"1\" width=\"20\" height=\"22\" rx=\"4\" /><circle cx=\"6\" cy=\"8\" r=\"1\" /><circle cx=\"6\" cy=\"16\" r=\"1\" /><path stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"2\" stroke-linecap=\"round\" d=\"M10 8h7M10 16h7\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol